"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { Tooltip } from "react-tooltip";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
interface WaveDropActionsOpenProps {
  readonly drop: ExtendedDrop;
  readonly isDropdownItem?: boolean | undefined;
  readonly onOpen?: (() => void) | undefined;
}
const WaveDropActionsOpen: React.FC<WaveDropActionsOpenProps> = t0 => {
  const $ = _c(26);
  const {
    drop,
    isDropdownItem: t1,
    onOpen
  } = t0;
  const isDropdownItem = t1 === undefined ? false : t1;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const canBeOpened = drop.drop_type !== ApiDropType.Chat;
  let t2;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t2 = drop_0 => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("drop", drop_0.id);
      router.push(`${pathname}?${params.toString()}`);
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onDropClick = t2;
  if (!canBeOpened) {
    return null;
  }
  if (isDropdownItem) {
    let t3;
    if ($[4] !== drop || $[5] !== onDropClick || $[6] !== onOpen) {
      t3 = () => {
        onDropClick(drop);
        onOpen?.();
      };
      $[4] = drop;
      $[5] = onDropClick;
      $[6] = onOpen;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="tw-h-4 tw-w-4 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg"><path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
      t5 = <span className="tw-text-sm tw-font-medium">Open</span>;
      $[8] = t4;
      $[9] = t5;
    } else {
      t4 = $[8];
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t3) {
      t6 = <button type="button" onClick={t3} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-iron-300 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-bg-iron-800">{t4}{t5}</button>;
      $[10] = t3;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t3;
  if ($[12] !== drop || $[13] !== onDropClick) {
    t3 = () => onDropClick(drop);
    $[12] = drop;
    $[13] = onDropClick;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const t4 = `open-${drop.id}`;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="tw-h-5 tw-w-5" xmlns="http://www.w3.org/2000/svg"><path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4) {
    t6 = <button type="button" className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-px-2 tw-text-iron-400 tw-transition-colors desktop-hover:hover:tw-text-white" onClick={t3} aria-label="Open drop" data-tooltip-id={t4}>{t5}</button>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const t7 = `open-${drop.id}`;
  let t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    };
    t9 = <span className="tw-text-xs">Open</span>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7) {
    t10 = <Tooltip id={t7} place="top" offset={8} opacity={1} style={t8}>{t9}</Tooltip>;
    $[21] = t7;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t6) {
    t11 = <>{t6}{t10}</>;
    $[23] = t10;
    $[24] = t6;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};
export default WaveDropActionsOpen;